import Raven from 'raven-js';
import environmentHelper from 'helpers/environment';
import configHelper from 'helpers/config';

let isConfigured = false;

/**
 * Configures the Sentry setup.
 */
const configure = function () {
    if (isConfigured) {
        throw new Error('Sentry should be configured once');
    }

    const sentryDsn = process.env.REACT_APP_SENTRY_DSN;

    if (!sentryDsn) {
        // Stop silently when no DSN is present
        return;
    }

    Raven.config(sentryDsn, {
        environment: environmentHelper.resolveEnvironment(),
        release: configHelper.getAppVersion(),
    }).install();

    isConfigured = true;
};

/**
 * Report an exception to Sentry through the saga.
 */
const sagaExceptionReporter = () => {
    return (next) => {
        return (action) => {
            try {
                return next(action);
            } catch (error) {
                if (!isConfigured) {
                    throw error;
                }

                Raven.captureException(error, {
                    extra: {
                        action: action,
                    },
                });
            }
        };
    };
};

const missingTranslationReporter = (key, _, locale) => {
    Raven.captureException(new Error(`Missing translation for locale '${ locale }' for key '${ key }'`), {
        logger: 'Missing translations',
        fingerprint: [
            '{{ default }}',
            'Missing translations',
        ],
    });

    return key;
};

export { configure, sagaExceptionReporter, missingTranslationReporter };



// WEBPACK FOOTER //
// ./src/helpers/Logging/sentry.js